import React, { useState } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import SQSHelper from "../../helpers/SQSHelper";
import { EMPTY, EMTCODE02 } from "../../configurations/Constants";
import { useSelector } from "react-redux";
import {
  ENTER_NAME,
  ENTER_ONLY_LETTERS,
  ERROR_SENDING_MESSAGE_TO_QUEUE,
} from "../../configurations/MessageConstants";

function NotifyAdminPopup(props) {
  const UserInfo = useSelector((state) => state.user.userInfo);

  const [buttonClicked, setButtonClicked] = useState(false);
  const [name, setName] = useState(EMPTY);
  const [validated, setValidated] = useState(false);

  const handleOnChange = (e) => {
    setName(e.target.value);
  };

  const handleAddRequest = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setButtonClicked(true);
    setValidated(false);

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setButtonClicked(false);
      setValidated(true);
    } else {
      const selectedFields = props.fields;
      const fields = selectedFields.map((field) => {
        return `${field.fieldName} (${field.irrig_unit_id})`;
      });
      try {
        const payload = {
          code: EMTCODE02,
          data: {
            user_email: UserInfo.user_email,
            phone: UserInfo.phone,
            first_name: UserInfo.first_name,
            last_name: UserInfo.last_name,
            irrig_unit_ids: fields,
            secondary_user_phone: props.mobilePhoneNumber,
            secondary_user_name: name,
          },
        };

        await SQSHelper.sendMessageToQueue(payload);
        props.afterSuccessful();
      } catch (error) {
        console.error(ERROR_SENDING_MESSAGE_TO_QUEUE, error);
      }
    }
  };

  const closeModal = () => {};

  return (
    <Modal
      show={props.showNotifyAdminPopup}
      onHide={closeModal}
      className="remove-crop"
    >
      <Modal.Header>
        <h3>Do you like to inform TPNRD about this?</h3>
      </Modal.Header>
      <Modal.Body>
        <Form
          key="popoverForm"
          noValidate
          validated={validated}
          onSubmit={(event) => handleAddRequest(event)}
        >
          <Row>
            <Form.Group as={Col} md="12">
              <p className="text-danger">
                The mobile phone number {props.mobilePhoneNumber} is not
                registered in TPNRD.
              </p>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} md="12" controlId="validationName">
              <Form.Label>
                Name of person with whom you want to share the field
                <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                maxLength="40"
                name="name"
                required
                value={name}
                onChange={handleOnChange}
                pattern="^[\s]*[A-Za-z]+[\s]*[A-Za-z\s'-]*"
              />
              <Form.Control.Feedback type="invalid">
                {name === EMPTY ? ENTER_NAME : ENTER_ONLY_LETTERS}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mt-3">
            <Form.Group
              as={Col}
              md="12"
              controlId="validationName"
              className="d-flex gap-2"
            >
              <Button type="submit" disabled={buttonClicked ? true : false}>
                Yes
              </Button>{" "}
              <Button
                type="button"
                onClick={(e) => props.closePopup(e)}
                disabled={buttonClicked ? true : false}
              >
                No
              </Button>
            </Form.Group>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default NotifyAdminPopup;
